import { LoaderFunctionArgs } from "react-router-dom";
import { Api } from "../api/Api";
import { paramIds } from "../api/ApiUtil";
import { DetectionLoaderData, parseCompressedObbDet } from "./detectionLoader";

export async function runListLoader( { params }: LoaderFunctionArgs ): Promise<any> {
    return null as any;
}